module.exports = __webpack_public_path__ + "static/media/07_digginglight.f2067f77.jpg";